import {
  makeStyles,
  Grid,
  useTheme,
  useMediaQuery,
  Box,
} from '@material-ui/core'
import Layout from '../components/common/Layout'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import AddToPhotosIcon from '@material-ui/icons/AddToPhotos'
import PrintIcon from '@material-ui/icons/Print'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import TextFormatIcon from '@material-ui/icons/TextFormat'
import AppStoreBadge from '../components/common/MobileAppBadges/AppStoreBadge'
import PlayStoreBadge from '../components/common/MobileAppBadges/PlayStoreBadge'
import clsx from 'clsx'

import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
  },
  page: {
    width: '100vw',
    flexGrow: 1,
    padding: '20px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  appImg: {
    width: '90%',
    maxWidth: 444,
    marginTop: theme.spacing(5),
  },
  title: {
    color: '#404041',
    ...theme.headerFont,
    fontWeight: 500,
    fontSize: 50,
    marginBottom: 0,
    [theme.breakpoints.down('sm')]: {
      margin: `0 ${theme.spacing(1)}px`,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 36,
    },
  },
  subtitle: {
    color: '#4F4F4F',
    fontWeight: 400,
    fontSize: 20,
    ...theme.headerFont,
    [theme.breakpoints.down('xs')]: {
      fontSize: 16,
    },
  },
  downloadGridOuter: {
    width: '100%',
    maxWidth: 1000,
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
  downloadGridInner: {
    padding: theme.spacing(2),
  },
  featuresGridOuter: {
    width: '100%',
    maxWidth: 1100,
  },
  featuresGridInner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: `${theme.spacing(3)}px ${theme.spacing(8)}px`,
    textAlign: 'center',
  },
  featureTitle: {
    marginBottom: 0,
    color: '#404041',
    fontWeight: 500,
    fontSize: 20,
    ...theme.headerFont,
  },
  featureDesc: {
    color: '#828282',
    fontWeight: 400,
    fontSize: 16,
  },
  greyBox: {
    backgroundColor: '#F5F5F5',
    borderRadius: 16,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    padding: theme.spacing(1),
    flexWrap: 'wrap',
  },
  groupTagFullWidthWrapper: {
    flex: '0 0 100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  customerGroupTag: {
    borderRadius: 6,
    padding: theme.spacing(1),
    color: 'white',
    width: 'fit-content',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  backgroundColorPrimary: {
    backgroundColor: theme.palette.primary.main,
  },
  backgroundColorGreen: {
    backgroundColor: '#27AE60',
  },
}))

const MobileAppPage = () => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const { t } = useTranslation('mobile-app')
  const Router = useRouter()
  const language = Router.locale

  const featuresData = [
    {
      title: t('features.compare-prices.title'),
      desc: t('features.compare-prices.desc'),
      icon: <MonetizationOnIcon fontSize="large" color="primary" />,
    },
    {
      title: t('features.create-order.title'),
      desc: t('features.create-order.desc'),
      icon: <AddToPhotosIcon fontSize="large" color="primary" />,
    },
    {
      title: t('features.print.title'),
      desc: t('features.print.desc'),
      icon: <PrintIcon fontSize="large" color="primary" />,
    },
    {
      title: t('features.pick-up.title'),
      desc: t('features.pick-up.desc'),
      icon: <LocalShippingIcon fontSize="large" color="primary" />,
    },
    {
      title: t('features.printtext.title'),
      desc: t('features.printtext.desc'),
      icon: <TextFormatIcon fontSize="large" color="primary" />,
    },
  ]

  const renderDownloadButtonsDesktop = () => (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      mt={4}
      mb={8}
    >
      <p>{t('download-here')}</p>
      <Box display="flex" flexDirection="row">
        <Box display="flex" flexDirection="column" alignItems="center">
          <img
            src="/static/img/shippop-app/shippopOnelinkAppQr.svg"
            alt="qr code SHIPPOP app"
            width={200}
            height={200}
          />
        </Box>
        <Box p={1} />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <AppStoreBadge shippopType="shippop" width={250} />
          <PlayStoreBadge shippopType="shippop" width={250} />
        </Box>
      </Box>
    </Box>
  )

  const renderDownloadButtonsMobile = () => (
    <Box display="flex" flexDirection="column" my={2}>
      <p style={{ marginBottom: 0 }}>{t('download-here')}</p>
      <Box display="flex" flexDirection="row">
        <AppStoreBadge shippopType="shippop" width={160} />
        <PlayStoreBadge shippopType="shippop" width={160} />
      </Box>
    </Box>
  )

  return (
    <div className={classes.root}>
      <Layout>
        <div className={classes.page}>
          <img
            src="/static/img/shippop-app/shippop_app.jpg"
            alt="SHIPPOP App"
            className={classes.appImg}
          />
          <h1 className={classes.title}>MAKE SHIPPING EASY WITH SHIPPOP APP</h1>
          <h2 className={classes.subtitle}>{t('main-subtitle')}</h2>
          {isMobile
            ? renderDownloadButtonsMobile()
            : renderDownloadButtonsDesktop()}
          <Grid
            container
            className={classes.featuresGridOuter}
            justify="center"
          >
            {featuresData.map((feature) => (
              <Grid
                item
                xs={12}
                sm={4}
                className={classes.featuresGridInner}
                key={feature.title}
              >
                {feature.icon}
                <h4 className={classes.featureTitle}>{feature.title}</h4>
                <p className={classes.featureDesc}>{feature.desc}</p>
              </Grid>
            ))}
          </Grid>
        </div>
      </Layout>
    </div>
  )
}

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      'common',
      'header',
      'footer',
      'pdpa',
      'mobile-app',
    ])),
  },
})

export default MobileAppPage
